import React from 'react';
import './AsideRunner.css';
import './AsideRunner320.css';
import './AsideRunner768.css';
import './AsideRunner1024.css';
import './AsideRunner1280.css';
import './AsideRunner1376.css';
import './AsideRunner1920.css';

import AsideRunnerLine from './AsideRunnerLine';

interface Props {
  cities: Array<string>
}

function AsideRunner(props: Props): JSX.Element {
  const { cities } = props;
  
  return (
    <aside className="aside-runner">
      <div className="aside-runner-lines">
        { Object.keys(Array.from({length: 3})).map((key) => <AsideRunnerLine key={`line-${key}`} className={`line-${key}`} cities={cities} />) }
      </div>
    </aside>
  );
}

export default AsideRunner;
